import "./ProyectosCommon.css";
import { BaseSmallModalFormComponent } from "../../../shared/components/modal/BaseSmallModalFormComponent";
import { CultivoResponse } from "../../../shared/response/proyectos/CultivoResponse";
import { CultivoPayload } from "../../../shared/services/api/payload/proyectos/CultivoPayload";
import { CultivoSaveService } from "../../services/proyectos/CultivoSaveService";

export class CultivoFormModal extends BaseSmallModalFormComponent<
  CultivoResponse,
  CultivoPayload,
  CultivoSaveService
> {
  private _nombre!: HTMLInputElement;
  private _meses!:  HTMLInputElement;

  constructor(
    private readonly _onSavedCb: (item: CultivoResponse) => void,
    private readonly _item?: CultivoResponse,
  ) {
    super(new CultivoSaveService());
  }

  protected get title(): string { return this._item ? "Editar cultivo" : "Nuevo cultivo"; }
  protected get saveText(): string { return "Guardar"; }

  protected renderBody(): string {
    const c = this._item;
    return `
      <div class="cl-form-fields">
        <div class="cl-form-group">
          <label class="cl-form-label" for="cul-nombre">Nombre <span class="cl-required">*</span></label>
          <input id="cul-nombre" class="sx-input" type="text" maxlength="150" value="${this._esc(c?.nombre ?? "")}" placeholder="Cacao">
        </div>
        <div class="cl-form-group">
          <label class="cl-form-label" for="cul-meses">Meses a cosecha <span class="cl-required">*</span></label>
          <input id="cul-meses" class="sx-input sx-input--numeric" type="number" min="0" step="1" value="${c?.mesesACosecha ?? ""}" placeholder="24">
          <span class="pr-form-note">Duración estimada desde la siembra hasta la primera cosecha.</span>
        </div>
      </div>
    `;
  }

  protected override onAfterRender(el: HTMLDivElement): void {
    this._nombre = el.querySelector<HTMLInputElement>("#cul-nombre")!;
    this._meses  = el.querySelector<HTMLInputElement>("#cul-meses")!;

    this._nombre.addEventListener("input", () => this._validate());
    this._meses.addEventListener("input", () => this._validate());
    this._validate();
  }

  protected buildPayload(): CultivoPayload {
    return {
      id: this._item?.id ?? null,
      nombre: this._nombre.value.trim(),
      mesesACosecha: Math.floor(Number(this._meses.value)),
    };
  }

  protected override onSaved(item: CultivoResponse): void {
    this._onSavedCb(item);
    this.dispose();
  }

  private _validate(): void {
    const ok = this._nombre.value.trim().length >= 1 && Number(this._meses.value) > 0;
    this.setSaveDisabled(!ok);
  }

  private _esc(s: string): string {
    return (s ?? "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;");
  }
}
